module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/tv-phone.ced0bc68.png";